import { GET_WIDGET_WALL_DATA, UPDATE_DEMO_POST, PHOTOBOOTH_UPDATE } from "./keys";


const initialState = {
    wallData: null
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_WIDGET_WALL_DATA: {
            return { ...state, wallData: action.payload }
        }
        case UPDATE_DEMO_POST: {
            if (!state.wallData?.wall) return state;
            return { ...state, wallData: { ...state.wallData, wall: { ...state.wallData.wall, Personalization: { ...state.wallData.wall.Personalization, demoWall: action.payload } } } }
        }
        case PHOTOBOOTH_UPDATE: {
            const currState = { ...state?.wallData };
            const photoBoothData = currState?.wall?.PhotoBoothSettings ?? {};
            const updatedPhotoBoothData = { ...photoBoothData, ...action.payload };
            currState.wall.PhotoBoothSettings = updatedPhotoBoothData;
            return { ...state, wallData: { ...currState } }
        }
        default:
            return { ...state }
    }
}